import { useQuery } from '@tanstack/react-query';

import { validateMeetingLink } from '@/api/v4/meetings.api';
import { QueryKey } from '@/config/query-client';

export const useValidateMeetingLink = (linkId: string) => {
  return useQuery({
    queryKey: [QueryKey.MeetingLink, 'validate', linkId],
    queryFn: () => validateMeetingLink({ linkId }),
    enabled: !!linkId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
};
